import {
  Injectable,
  ComponentRef,
  EmbeddedViewRef
} from '@angular/core';
import { JoyrideStepComponent } from '../components';
import { JoyrideStep } from '../joyride.domain';

@Injectable({ providedIn: 'root' })
export class JoyrideStepDrawerService {
  private refMap: { [key: string]: ComponentRef<JoyrideStepComponent> } = {};

  draw(step: JoyrideStep): void {
    // 1. Create a component reference from the component
    const ref: ComponentRef<JoyrideStepComponent> = step.targetViewContainer
      .createComponent(JoyrideStepComponent);

    // 2. Get DOM element from component
    const domElem = (ref.hostView as EmbeddedViewRef<unknown>)
      .rootNodes[0] as HTMLElement;

    // 3. Append DOM element to the body
    document.body.appendChild(domElem);

    const instance: JoyrideStepComponent = ref.instance;
    instance.step = step;
    ref.changeDetectorRef.detectChanges();
    step.stepInstance = instance;

    this.refMap[step.name] = ref;
  }

  remove(step: JoyrideStep): void {
    this.refMap[step.name].destroy();
  }
}
